import { buildHttpHeaders } from "../utils/buildHttpHeaders";
import { getIdentityClientSettings } from "../utils/localStorage";

const PATH = '/api/userInfo';

export async function getUserInfoAsync(accessToken: string, backendHeader: string) {
    try {
        const response = await fetch(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}` + `${PATH}`, {
            method: 'GET',
            headers: buildHttpHeaders(accessToken, backendHeader)
        });

        if (response.status === 200) {
            const userinfo: any = await response.json();

            return userinfo;
        }
        return {};
        //   throw new Error(await response.text());
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function getLoginFlowAsync(clientId: string) {
    const { handymanApiUrl } = getIdentityClientSettings();

    const response = await fetch(`${PATH}/getLoginFlow`, {
        headers: {
            'Backend': clientId,
            'HandymanApiUrl': handymanApiUrl
        }
    });

    if (response.ok) return response.text();

    if (response.status === 400) {
        throw new Error('INVALID_CLIENT');
    }

    throw new Error(await response.text());
}